import { put, call, fork, spawn, select, take, takeEvery, cancel, delay } from 'redux-saga/effects'
import config from 'config'
import bowser from 'bowser'
import { getParameterByName } from '../../Utils'
import { getFromLocalStorage, setToLocalStorage } from '../../Utils'
import { muteAll, muteSFX, muteMusic } from '../../Sounds'
import {
  ON_TOKEN, LOGIN, ON_LOGIN, PLAY, ON_PLAY_RESPONSE, PLAY_DONE, PLAY_DONE_CHECK, UPDATE_BET, UPDATE_SIDE_BET,
  SET_BET, SAVE_SETTINGS, SETTINGS_SAVED, UPDATE_STATS, RESET_REALITYCHECK, UPDATE_WIN, SET_DELAYING_SPIN,
  TOGGLE_MUTE, SET_MUTE, TOGGLE_SETTINGS_OPEN, SET_SETTINGSSCREEN, SET_RESTORESTATE, REFRESH_FREEROUNDS,
  SETTINGSCREENS, TOGGLE_SPACE_TO_SPIN, SET_SPACE_TO_SPIN, ATTEMPT_TO_SPIN, KEY_UP, GAME_ACTIONS,
  UPDATE_FREEROUND_TOTAL, SET_SAVEDSETTINGS, SET_FREEROUNDS_LEFT, SHOW_MESSAGE, SET_HIDE_SPLASH,
  UPDATE_FREEROUNDS_LEFT, MESSAGE_TYPES, FUN_MONEY_LOGIN, TOGGLE_SFX, TOGGLE_MUSIC,
  READY, SET_LOGGEDIN, SET_SKIPFEATURE, ADD_ENABLE_QUICKSPIN, SET_QUICKSPIN, SET_SIDE_BET,
  SET_QUICKSPIN_PROMPT_SHOWN, RERUN_LAST_ROUND, MAKE_FREEROUND_CHOICE, READY_FOR_PLAY_DONE,
  TOURNAMENTPOINTS, SET_ALLOW_SPIN_REQUESTS, SET_FREEROUNDS_BET, REQUEST_BALANCE_UPDATE, FORCE_NEW_BALANCE,
  SET_SIDE_GAMES, SET_SETTING, CLOSE_GAMEROUND, CALLED_GAMEFINISHED,

  // POSTMESSAGE
  GAME_IS_READY,
} from '../constants'
import request from './request'
import errorSaga from './error'
import loadSaga from './loading'
import dialogDebug from './dialogDebug'
import {
  onRefresh, updateStats, message, setSkipFeature, play, setPlaying,
  setMuteSFX, setMuteMusic, restoreSettings, playRequest, updateJackpot, setAllowSpinRequests,
  setFallbackResponse, hideSplash, setBet, displayFreeround, readyForPlayDone,
  onStartRestore,
} from '../actions'
import { setSpins } from '../../components/autoplay/actions'
import { timeUntilExpiration } from '../../Utils'
import Currency from '../../Utils/Currency'
import delayOrSkip from '../../Utils/delayOrSkip'

/**
 * isDesktop is used to detect whether localStorage can be used for sound settings.
 * @returns {boolean}
 */
const isDesktop = () => (!bowser.msie && !bowser.ios && !bowser.tablet && !bowser.mobile)
let pendingMessages = null
let _freeroundsDirty = false
let _freeroundExpiryFork

/**
 * Creates a list of sagas that should be run on specific events.
 */
export default function* watchFetchData() {
  yield fork(errorSaga)
  yield fork(loadSaga)
  yield fork(dialogDebug)
  yield takeEvery(LOGIN, login)
  yield takeEvery(READY, ready)
  yield takeEvery(ON_TOKEN, onTokenResponse)
  yield takeEvery(FUN_MONEY_LOGIN, funMoneyLogin)
  yield takeEvery(PLAY, sendPlay)
  yield takeEvery(ON_PLAY_RESPONSE, onPlayResponse)
  yield takeEvery(SET_RESTORESTATE, setRestoreState)
  yield takeEvery(SET_SAVEDSETTINGS, setSavedSettings)
  yield takeEvery(CLOSE_GAMEROUND, closeGameRound)
  yield takeEvery(UPDATE_BET, updateBet)
  yield takeEvery(UPDATE_SIDE_BET, updateSideBet)
  yield takeEvery(SAVE_SETTINGS, saveSavedSettings)
  yield takeEvery(UPDATE_STATS, statsUpdated)
  yield takeEvery(RESET_REALITYCHECK, doResetReality)
  yield takeEvery(READY_FOR_PLAY_DONE, onReadyForPlayDone)
  yield takeEvery(PLAY_DONE_CHECK, checkPlay)
  yield takeEvery(TOGGLE_MUTE, onMuteToggle)
  yield takeEvery(TOGGLE_SFX, onMuteSFXToggle)
  yield takeEvery(TOGGLE_MUSIC, onMuteMusicToggle)
  yield takeEvery(SET_MUTE, onSetMute)
  yield takeEvery(TOGGLE_SETTINGS_OPEN, onSettingsToggle)
  yield takeEvery(TOGGLE_SPACE_TO_SPIN, onSpaceToSpinToggle)
  yield takeEvery(ATTEMPT_TO_SPIN, attemptToSpin)
  yield takeEvery(SET_FREEROUNDS_LEFT, updateFreeRoundsLeft)
  yield takeEvery(KEY_UP, onKeyUp)
  yield takeEvery(SET_SKIPFEATURE, onSetSkipfeature)
  yield takeEvery(RERUN_LAST_ROUND, reRunLastRound)
  yield takeEvery(MAKE_FREEROUND_CHOICE, sendFreeRoundAction)
  yield takeEvery(SET_FREEROUNDS_BET, onSetFreeroundsBet)
  yield takeEvery(REFRESH_FREEROUNDS, refreshFreerounds)
  yield takeEvery(REQUEST_BALANCE_UPDATE, updateBalance)
  yield takeEvery(SET_QUICKSPIN, onSetQuickspin)

  if (isDesktop()) {
    yield call(addSounds)
  }
}

export function* addSounds() {
  const mute = getFromLocalStorage('muted') === 'true'
  const mutedSFX = getFromLocalStorage('mutedSFX') === 'true'
  const mutedMusic = getFromLocalStorage('mutedMusic') === 'true'

  const useSFX = !mute && mutedSFX
  const useMusic = !mute && mutedMusic

  yield put({ type: SET_MUTE, mute })
  yield put(setMuteSFX(useSFX))
  yield put(setMuteMusic(useMusic))
  muteSFX(useSFX)
  muteMusic(useMusic)
}

/**
 * Saga run on the LOGIN event.
 * Will attempt to request token for the user.
 * @returns {boolean}
 */
export function* login() {
  const { session } = yield select()

  const { ticket } = session

  if (!session.partnerid) {
    console.log('[Connection] - No partner id set, cannot login')
    return false
  }

  const params = {
    gameref: config.GAME_CONFIG.GAME_ID,
    ticket,
    partnerid: session.partnerid,
    mode: session.mode,
    channel: session.channel,
    clientid: session.clientid,
    clientversion: config.version
  }

  console.log(`Getting token ${session.tokenAPIEndpointURL}`)

  const url = session.tokenAPIEndpointURL

  const response = yield call(request, url, params)

  yield put({
    type: ON_TOKEN,
    response
  })
}


/**
 * Saga run on the FUN_MONEY_LOGIN event.
 * Will login in Demo mode, no user required.
 */
export function* funMoneyLogin(action) {
  const { session } = yield select()
  const { prototypeStats } = action

  const params = {
    userid: session.userid,
    mode: session.mode,
    partnerid: session.partnerid,
    channel: session.channel,
    clientid: session.clientid,
    g: config.GAME_CONFIG.GAME_ID,
    immediatePayouts: session.immediatePayouts,
    prototypeStats: prototypeStats,
    clientversion: config.version,
    jurisdiction: session.jurisdiction
  }

  let loginChannel = config.SERVER_CONFIG.FUN_LOGIN
  const currency = getParameterByName('currency')

  if (currency) {
    loginChannel = config.SERVER_CONFIG.DEMO_LOGIN
    params.currency = currency
  }

  const url = session.gameServerAPIendpointURL + loginChannel

  const response = yield call(request, url, params)

  yield call(onLogin, response)
}

/**
 * Saga run on ON_TOKEN event.
 * Will attempt to login, using the received information.
 * @param {object} action - Object containing user information needed for login.
 */
export function* onTokenResponse(action) {
  const { response } = action
  console.log('[Connection] - onTokenResponse', response)

  if (response.status === 'ok') {
    const { session } = yield select()

    const params = {
      token: response.response.token,
      userid: response.response.userid,
      mode: session.mode,
      partnerid: session.partnerid,
      channel: session.channel,
      clientid: session.clientid,
      g: config.GAME_CONFIG.GAME_ID,
      immediatePayouts: session.immediatePayouts,
      acceptFreespinsMidsession: true,
      clientversion: config.version
    }

    const loginURL = session.moneymode === 'fun' ? config.SERVER_CONFIG.DEMO_LOGIN
      : config.SERVER_CONFIG.RM_LOGIN

    // Token ok, logging using received data
    const url = session.gameServerAPIendpointURL + loginURL

    const res = yield call(request, url, params)

    yield call(onLogin, res)
  } else {
    console.log(`[Connection] - Unhandled token response status, ${response.status}`)
  }
}

function GetBetAmount(response, freeRounds, forced, settings) {
  let bet, betLines

  if (forced) {
    bet = freeRounds.ba
    betLines = freeRounds.l
  } else {
    bet = settings.lastBet || response.correspondingBa || response.mainGameBa || response.ba
    betLines = settings.lastBetLines || settings.lastBetEnhancer || response.l // TODO: remove settings.lastBetEnhancer
  }

  return { bet, betLines: betLines || 1 }
}

/**
 * Saga called on ON_LOGIN event.
 * Will handle initialization of settings, free rounds, bets, reality check
 * as well as letting the game know that it is ready.
 * @param {object} response - Object containing information about everything
 * related to the current state of the user or the game.
 */
export function* onLogin(response) {
  console.log('[Connection] - onLogin', response)
  const { base } = yield select()
  const { savedSettings, refresh = {} } = response

  response.isLogin = true

  yield put(restoreSettings(savedSettings))

  yield put({
    type: ON_LOGIN,
    response
  })

  Currency.init()

  if (config.disableSpinUntilGameFinished && !refresh.ended && refresh.win === 0) {
    yield fork(callGameFinished)
  }

  const { soundAvailable, settings = {} } = yield select(state => state.base)
  const { stats } = response

  const restore = refresh.restoreState && refresh.restoreState.charAt(0) === '{' ?
    JSON.parse(refresh.restoreState) : refresh.restoreState
  let freeRounds = (restore && restore.freeRounds) || (stats && stats.freespins)
  if (freeRounds) {
    freeRounds = { ...freeRounds, spinsended: (freeRounds.spinsended && !restore) } // Ensure that we show the prompt on the last spin
    if (freeRounds.l) {
      freeRounds.ba = freeRounds.l * freeRounds.la
    }
  }
  const expiryTime = freeRounds && timeUntilExpiration(freeRounds.expires)
  const freeroundsActive = freeRounds && (!freeRounds.spinsended && (freeRounds.imsFreespins || expiryTime > 0))
  const forced = freeroundsActive && freeRounds.spinsPlayed && freeRounds.ba

  const showFreeroundsPropmpt = forced || (!restore && freeroundsActive)

  const { config: conf } = response

  if (conf) {
    const { rtp, buyFeatureRtp } = conf
    if (!isNaN(rtp)) { config.RTP = (rtp * 100).toFixed(2) }

    if (!isNaN(buyFeatureRtp)) { config.BUYRTP = (buyFeatureRtp * 100).toFixed(2) }

    config.loginConfig = conf
  }

  if (response.sideGames) {
    yield put({
      type: SET_SIDE_GAMES,
      sideGames: response.sideGames
    })
  }

  if (response.messages) {
    pendingMessages = response.messages
  }

  if (!base.playing) {
    if (!showFreeroundsPropmpt) {
      yield put(onRefresh(response))
    }
    yield spawn(startPinging, refresh)
    if (response.refresh && response.refresh.jackpot) {
      yield spawn(startPollingJackpot)
    }
  }

  yield call(setRealityCheck)

  refresh.refresh = true

  yield put({ type: SET_LOGGEDIN, loggedIn: true })

  const { allowSpinRequests } = yield select(state => state.base)
  if (!allowSpinRequests) {
    yield take(SET_ALLOW_SPIN_REQUESTS)
  }

  yield put({ type: GAME_IS_READY })

  const { hasSplash, hideSplash: _hidesplash } = yield select(state => state.base)

  if (savedSettings && savedSettings.noSplashScreen) {
    yield put(hideSplash())
  } else if (hasSplash && !_hidesplash) {
    yield take(SET_HIDE_SPLASH)
  }

  const { bet, betLines } = GetBetAmount(refresh, freeRounds, forced, settings)

  yield put({
    type: UPDATE_BET,
    bet,
    betLines,
    forced
  })

  if (response.sideGames) {
    const keys = Object.keys(response.sideGames)
    let i = keys.length
    while (i--) {
      const sideGameName = keys[i]
      // Set sideBets to 0 if in freerounds.
      yield put({
        type: UPDATE_SIDE_BET,
        bet: freeroundsActive ? 0 : response.sideGames[sideGameName].ba,
        sideGameName
      })
    }
  }

  // Don't show the sound prompt to players with no sound
  if (soundAvailable && (bowser.mobile || bowser.tablet)) {
    yield put(message({
      type: MESSAGE_TYPES.SOUND_PROMPT,
      noCloseButton: true
    }))
  }

  if (pendingMessages) {
    for (const _message of pendingMessages) {
      yield put(message({
        message: `<div><b>${_message.title}</b></div><br/>${_message.message}`
      }))
      yield take(SHOW_MESSAGE)
    }
    pendingMessages = null
  }

  if (showFreeroundsPropmpt) {
    yield freeroundsPrompt(freeRounds)
    _freeroundExpiryFork = yield fork(onFreeroundsExpired, expiryTime)
  }
}

function* freeroundsPrompt(freeRounds) {
  yield put(setSpins(0))

  yield put(message({
    type: MESSAGE_TYPES.FREEROUNDS,
    data: freeRounds
  }))

  const isTournament = freeRounds.type === TOURNAMENTPOINTS
  yield put(displayFreeround(true, isTournament))
}

/**
 * Saga that starts when everything has been loaded
 */
export function* ready() {
  // Allow spin requests once everything has loaded
  yield put(setAllowSpinRequests(true))
}

/**
 * Saga that starts a task to ping the backend on a set interval (60 seconds).
 */
export function* startPinging() {
  try {
    while (true) {
      const { session } = yield select()

      const url = `${session.gameServerAPIendpointURL}/ping`

      const params = { sid: session.sid }

      const res = yield call(request, url, params)

      if (!res.errorCode)
        yield put(updateStats(res))

      yield delay(600000)
    }
  } catch (e) {
    console.log(`ERROR! ${  e}`)
    yield delay(60000)
    yield spawn(startPinging)
  }
}

/**
 * Saga that starts a task to poll the jackpot from the backend, on a set interval (30 seconds).
 */
export function* startPollingJackpot() {
  try {
    while (true) {
      const { session, base } = yield select()
      const { playStart = 0 } = base
      const timeNow = Date.now()
      const difference = (timeNow - playStart)

      // We don't need to poll again, if we recently made a play/pick request.
      if (difference < 30000) {
        yield delay(30000 - difference)
      } else {
        const url = `${session.gameServerAPIendpointURL}/getjackpot`
        const params = { sid: session.sid, g: config.GAME_CONFIG.GAME_ID }
        const res = yield call(request, url, params)

        yield put(updateJackpot(res))
        yield delay(30000)
      }
    }
  } catch (e) {
    console.error('[Jackpot Request] ERROR!', e)
    yield delay(30000)
    yield spawn(startPollingJackpot)
  }
}
/**
 * Saga that seconds a play request to the backend.
 * Will also dispatch a Quick spin feature prompt, if the
 * @param {object} action - Object containing information of the play request.
 */
export function* sendPlay(action) {
  const { base } = yield select()
  const { allowSpinRequests, quickSpinPromptShown = false } = base
  if (!allowSpinRequests) { return }
  const { params } = action
  const { enableQuickspinCounter } = yield select(state => state.base)
  const { FEATURE_CONFIG = {} } = config
  const { QUICKSPIN_ENABLE_COUNTER = 5 } = FEATURE_CONFIG


  // Check for idle expiry timers.
  if (_freeroundExpiryFork) {
    yield cancel(_freeroundExpiryFork)
  }

  const { settings } = yield select(state => state.base)

  // Trigger show quickspin prompt if conditions are met
  if (!settings.quickSpin && !quickSpinPromptShown && enableQuickspinCounter >= QUICKSPIN_ENABLE_COUNTER) {
    yield put({
      type: SET_QUICKSPIN_PROMPT_SHOWN,
      shown: true
    })
    yield put(message({
      type: MESSAGE_TYPES.QUICKSPIN_PROMPT
    }))
  }

  const { spinDelay } = config.JURISDICTION_CONFIG
  if (spinDelay) {
    yield fork(delaySpin, spinDelay, base.playStart)
  }

  if (params.ga === GAME_ACTIONS.SPIN) {
    yield put({ type: GAME_ACTIONS.SPIN })
    yield put({
      type: UPDATE_WIN,
      win: 0
    })
  }

  const { session } = yield select()

  if (!session.sid)
    return

  yield put(setAllowSpinRequests(false))

  const url = `${session.gameServerAPIendpointURL}/play`

  const restore = { ...params.restoreState }
  const restoreState = (!session.immediatePayouts || params.restoreState) ?
    JSON.stringify(restore) : undefined

  const send = {
    g: config.GAME_CONFIG.GAME_ID,
    sid: session.sid,
    restoreState,
    restoreVersion: ++session.restoreVersion,
    ba: session.betAmount
  }

  const { sideGames } = base
  if (sideGames && sideGames.length > 0) {
    sideGames.forEach(sideGame => {
      if (sideGame.betAmount > 0) {
        send[`${sideGame.sideGameName}Bet`] = sideGame.betAmount
      }
    })
  }

  Object.keys(params).forEach(arg => {
    send[arg] = params[arg]
  })

  const response = (yield call(request, url, send)) || undefined
  const isError = !response || !!(response && response.errorCode)

  if (!isError) {
    yield put(setFallbackResponse(response))
  }

  yield put({
    type: ON_PLAY_RESPONSE,
    response,
    isError
  })

  yield put(setAllowSpinRequests(true))
}

export function* onPlayResponse(action) {
  const { response } = action

  if (!config.disablePlayermessage && response && response.messages) {
    pendingMessages = response.messages
  }
}

export function* delaySpin(spinDelay, playStart) {
  const timeDelay = (typeof spinDelay) === 'boolean' ? 3000 : Number(spinDelay)
  const timeDiff = Date.now() - (playStart || 0)
  yield put({ type: SET_DELAYING_SPIN, delay: true })
  if (timeDiff < timeDelay) {
    yield delay(timeDelay - timeDiff)
  }
  yield put({ type: SET_DELAYING_SPIN, delay: false })
}

/**
 * Saga that will store a restore state on the server, to let
 * the user continue from said state if the game is refreshed.
 * @param {object} action - Object containing information about the new restore state.
 */
export function* setRestoreState(action) {
  const { session, base } = yield select()
  const { response, restoreStateDisabled } = base

  if (!session.sid || restoreStateDisabled || response.replay)
    return

  const freeRounds = (session.restoreState && session.restoreState.freeRounds) ||
    (response && response.stats && response.stats.freespins)
  action.restoreState.visibleFreeRoundWin = base.visibleFreeRoundWin
  if (freeRounds) {
    freeRounds.spins = session.freeRoundSpins
    action.restoreState.freeRounds = freeRounds
  }

  const restoreState = JSON.stringify(action.restoreState)
  const url = `${session.gameServerAPIendpointURL}/setrestorestate`

  const send = {
    g: config.GAME_CONFIG.GAME_ID,
    sid: session.sid,
    restoreState,
    restoreVersion: ++session.restoreVersion
  }

  yield call(request, url, send)
}

/**
 * Saga that will send a set of settings to the server, to be stored.
 */
export function* setSavedSettings() {
  const { base } = yield select()

  if (isDesktop()) {
    setToLocalStorage('muted', `${base.muted}`)
    setToLocalStorage('mutedSFX', `${!base.muted && base.mutedSFX}`)
    setToLocalStorage('mutedMusic', `${!base.muted && base.mutedMusic}`)
  }

  yield saveSavedSettings()
}

export function* closeGameRound() {
  const { didCallGameFinished } = yield select(state => state.base)
  if (didCallGameFinished) { return }
  yield put({ type: CALLED_GAMEFINISHED })

  let finishedResponse
  if (config.disableSpinUntilGameFinished) {
    while (!finishedResponse) {
      finishedResponse = yield call(callGameFinished)
      if (!finishedResponse) {
        yield take(e => e.type === SHOW_MESSAGE && e.message === null)
      }
    }
  } else { 
    yield fork(callGameFinished)
  }
  return finishedResponse
}

/**
 * Saga that will send a `gamefinished` call to the server,
 * which will let the server know that the client has finished playing the round.
 */
export function* callGameFinished() {
  const { session } = yield select()

  if (!session.sid)
    return

  const url = `${session.gameServerAPIendpointURL}/gamefinished`

  const send = {
    g: config.GAME_CONFIG.GAME_ID,
    sid: session.sid,
    restoreVersion: ++session.restoreVersion
  }

  return yield call(request, url, send)
}

/**
 * Saga called on PLAY_DONE_CHECK event.
 * It will enforce the spin delay needed between each spin (e.g. 3 seconds).
 */
export function* checkPlay() {
  const { delayingSpin } = yield select(state => state.base)

  if (delayingSpin) {
    yield take(SET_DELAYING_SPIN)
  }
  yield put(readyForPlayDone())
}

/**
 * Saga called on after the game round has finished and the spin delay has been passed.
 * Will handle displaying of any message at the end of the round (e.g. free round finished),
 * and updating of invalid bet values.
 */
export function* onReadyForPlayDone() {
  const { session, base } = yield select()
  if (!base.response) {
    yield call(endRound, true)
    return
  }

  if (typeof base.response.win === 'number') {
    yield put({ type: UPDATE_WIN, win: base.response.win })
  }

  const freeRounds = (base.response && base.response.stats && base.response.stats.freespins) ||
    (session.restoreState && session.restoreState.freeRounds)

  let hideFreerounds = false
  let freeroundsEnded = false

  if (freeRounds) {
    const expiryTime = timeUntilExpiration(freeRounds.expires)
    freeroundsEnded = freeRounds.spinsended || expiryTime <= 0
    if (!freeroundsEnded) {
      if (_freeroundExpiryFork) {
        yield cancel(_freeroundExpiryFork)
        _freeroundExpiryFork = undefined
      }
      // Start a timer, incase the freerounds expire while the player is idling.

      _freeroundExpiryFork = yield fork(onFreeroundsExpired, expiryTime)
    }
    freeRounds.ba = freeRounds.l ? freeRounds.l * freeRounds.la : freeRounds.ba
    if (!base.displayFreeRound && !freeroundsEnded) {
      yield freeroundsPrompt(freeRounds)
    }

    yield put({
      type: UPDATE_FREEROUND_TOTAL,
      win: freeRounds.win + (freeroundsEnded ? 1 : 0) // Adds one if freespins so that the UI skips count-up
    })

    const currentDisplay = yield select(state => state.base.displayFreeRound)
    if (currentDisplay && freeroundsEnded) {
      //Commented out due to uncertainties when it comes to expectations on game-behaviour
      //yield put({ type: UPDATE_WIN, win: freeRounds.win })
      yield put({
        type: UPDATE_FREEROUND_TOTAL,
        win: freeRounds.win
      })
      yield delay(1000)
      yield put(message({
        type: MESSAGE_TYPES.FREEROUNDS,
        data: freeRounds
      }))

      yield take(SHOW_MESSAGE)
      hideFreerounds = true
    }
  }

  // Failsafe, if for some reason the FreeRound display is active, but there are none in the response.
  if (!freeRounds && (yield select(state => state.base.displayFreeRound))) {
    hideFreerounds = true
  }

  if (hideFreerounds) {
    yield put(setSpins(0))
    yield put(displayFreeround(false, false))
    _freeroundsDirty = true
  }

  if (freeroundsEnded || !base.response.restoreState) {
    const forced = (freeRounds && (freeRounds.spinsPlayed && !freeroundsEnded))
    let { bet, betLines } = GetBetAmount(base.response, freeRounds, forced, base.settings)

    if (!forced) {
      const { balance, legalBets } = session
      if (balance < bet && !config.disableAutoBetLowering) {
        let betIndex = legalBets.indexOf(session.betAmount)
        while (betIndex > 0) {
          if (balance >= legalBets[betIndex]) {
            break
          }
          betIndex -= 1
        }
        bet = legalBets[betIndex]
      }
    }

    yield put({
      type: UPDATE_BET,
      bet,
      betLines,
      forced
    })
  }

  if (base.response.win) {
    yield delayOrSkip(750) //Compensation for balance-field update
  }

  yield call(endRound)
}

/**
 * Saga that will be delayed until freerounds have expired, to make sure that the
 * client gets notified of expired freerounds.
 * @param {Number} timeRemaining 
 */
export function* onFreeroundsExpired(timeRemaining) {
  const { session, base } = yield select()
  const freeRounds = (base.response && base.response.stats && base.response.stats.freespins) ||
    (session.restoreState && session.restoreState.freeRounds)

  // Return if imsFreespins or if time remaining is larger than 24 hours.
  if (!freeRounds || freeRounds.imsFreespins || timeRemaining > (60 * 60 * 24 * 1000)) {
    return
  }

  yield delay(timeRemaining)
  yield put({ type: UPDATE_WIN, win: freeRounds.win })
  yield put({
    type: UPDATE_FREEROUND_TOTAL,
    win: freeRounds.win
  })
  yield delay(1000)
  yield put(message({
    type: MESSAGE_TYPES.FREEROUNDS,
    data: freeRounds
  }))

  yield take(SHOW_MESSAGE)
  yield put(setSpins(0))
  yield put(displayFreeround(false, false))

  const { bet, betLines } = GetBetAmount(base.response, freeRounds, false, base.settings)
  yield put({
    type: UPDATE_BET,
    bet,
    betLines
  })

  return
}

/**
 * Saga that will update the current bet when a freeround bet is chosen.
 * @param {Object} - Contains a freeroundsBet variable.
 */
export function* onSetFreeroundsBet({ freeroundsBet, freeroundsBetLines }) {
  yield put({
    type: UPDATE_BET,
    bet: freeroundsBet,
    betLines: freeroundsBetLines,
    forced: true
  })
}

/**
 * Saga that will set the round inactive call necessary sagas
 * to let the server know of this.
 * @param skip
 */
export function* endRound(skip) {
  const { base, session } = yield select()

  if (skip) {
    yield put({ type: PLAY_DONE })
    return
  }

  const finishedResponse = yield call(closeGameRound)

  const { rcIntervalEnabled = false } = base
  const { realityCheck = {}, moneymode } = session
  const shouldShowRC = !rcIntervalEnabled && realityCheck.status === 'error' && moneymode !== 'fun' && moneymode !== 'demo'

  if (shouldShowRC) {
    yield call(checkRealityCheck, session.realityCheck)
  }

  yield put({ type: PLAY_DONE, finishedResponse })

  if (pendingMessages) {
    for (const _message of pendingMessages) {
      yield put(message({
        message: `<div><b>${_message.title}</b></div><br/>${_message.message}`
      }))

      yield take(SHOW_MESSAGE)
    }
    pendingMessages = null
  }

  if (base.skipfeature)
    yield put(setSkipFeature(false))


  if (_freeroundsDirty && session.sid) {
    _freeroundsDirty = false
    yield put({ type: REFRESH_FREEROUNDS })
  }
}

function* refreshFreerounds() {
  const { session } = yield select()

  const params = {
    g: config.GAME_CONFIG.GAME_ID,
    sid: session.sid
  }

  const url = `${session.gameServerAPIendpointURL}/refresh/`
  const { stats } = yield call(request, url, params)
  const freeRounds = stats && stats.freespins
  const expiryTime = freeRounds ? timeUntilExpiration(freeRounds.expires) : 0

  if (freeRounds && !freeRounds.spinsended && (freeRounds.imsFreespins || expiryTime > 0)) {
    yield freeroundsPrompt(freeRounds)
    if (_freeroundExpiryFork) {
      yield cancel(_freeroundExpiryFork)
      _freeroundExpiryFork = yield fork(onFreeroundsExpired, expiryTime)
    }
  }
}

/**
 * Saga that updates the current bet values
 * @param {object} action - Object that contains information about the new bet value.
 */
export function* updateBet(action) {
  const { base, session } = yield select()
  const { change, bet, betLines, forced } = action

  if (!session.legalBets)
    return

  let betIndex = Math.max(0, session.legalBets.indexOf((bet || session.betAmount) / (bet && betLines ? betLines : session.betLines || 1)))

  if (change) {
    betIndex += change
  }

  const state = {
    canDecrease: betIndex > 0,
    canIncrease: betIndex < session.legalBets.length - 1,
    forcedBet: forced,
    betAmount: session.legalBets[betIndex] * (betLines || session.betLines || 1),
    betLines: betLines || session.betLines,
  }

  yield put({
    type: SET_BET,
    payload: state
  })

  const { settings } = base
  if (!forced && (!settings || settings.lastBet !== state.betAmount || settings.lastBetLines !== state.betLines)) {
    yield put({ type: SET_SETTING, setting: 'lastBet', value: state.betAmount })
    yield put({ type: SET_SETTING, setting: 'lastBetLines', value: state.betLines })
    yield saveSavedSettings()
  }
}

/**
 * Saga that updates the current sideBet values
 * @param {object} action - Object that contains information about the new sideBet value.
 */
export function* updateSideBet(action) {
  const { bet, sideGameName } = action
  const { base } = yield select()
  const { sideGames = [] } = base

  if (!sideGames.length > 0)
    return

  let newBet = 0

  const sideGame = sideGames.find(a => a.sideGameName === sideGameName)
  if (sideGame) {
    const betIndex = sideGame.legalBets.indexOf(bet)
    if (betIndex === -1) {
      newBet = 0
    } else {
      newBet = sideGame.legalBets[betIndex]
    }

    yield put({
      type: SET_SIDE_BET,
      betAmount: newBet,
      sideGameName
    })
  }
}

/**
 * Sends the current settings to server
 */
function* saveSavedSettings() {
  const { session, base } = yield select()

  // No point in saving settings if there is no session
  if (!session.sid) {
    return
  }

  const url = `${session.gameServerAPIendpointURL}/setsavedsettings`

  const params = {
    g: config.GAME_CONFIG.GAME_ID,
    sid: session.sid,
    savedSettings: JSON.stringify(base.settings || {})
  }

  // TODO: Could use a debounce...
  const response = yield call(request, url, params)

  yield put({
    type: SETTINGS_SAVED,
    response
  })
}

/**
 * Saga called on when session stats have been updated.
 * @param action
 */
export function* statsUpdated(action) {
  const { base, session: { moneymode } } = yield select()
  const { playing, rcIntervalEnabled = false } = base

  if (playing)
    return

  const { stats } = action
  if (!stats)
    return

  const { realityCheck = {} } = stats
  const shouldShowRC = !rcIntervalEnabled && realityCheck.status === 'error' && moneymode !== 'fun' && moneymode !== 'demo'
  if (!shouldShowRC) {
    return
  }

  yield call(checkRealityCheck, stats.realityCheck)
}

/**
 * Saga that will set the reality check limits on login, using the
 * limits received in the query parameters.
 */
export function* setRealityCheck() {
  const { session } = yield select()
  const url = `${session.gameServerAPIendpointURL}/setrealitychecklimits`

  const params = {
    sid: session.sid,
    sessionLimitSeconds: session.rcinterval,
    sessionElapsedSeconds: session.rcelapsed || 0,
  }

  yield call(request, url, params)
}

/**
 * Saga that checks if it should be displayed, and then dispatches the Reality check.
 * @param {object} realityCheck - Object containing information about the Reality check.
 */
export function* checkRealityCheck(realityCheck = {}) {
  const { status } = realityCheck
  const { session = {} } = yield select()
  const { moneymode, rcshowresult = false } = session

  if (moneymode === 'fun' || moneymode === 'demo' || status !== 'error' ||
    (session.rcenable && session.rciframeurl))
    return

  if (rcshowresult) {
    const params = { sid: session.sid }
    const url = `${session.gameServerAPIendpointURL}/getsessionresult`
    const response = yield call(request, url, params)
    realityCheck.betSum = response.betamount
    realityCheck.winSum = response.winamount
    realityCheck.result = response.winamount - response.betamount
  }

  yield put(message({
    type: MESSAGE_TYPES.REALITYCHECK,
    data: realityCheck,
    noCloseButton: true
  }))
}

/**
 * Saga that will send a reset request to the server, to reset the Reality check timer.
 */
export function* doResetReality() {
  const { session } = yield select()
  const url = `${session.gameServerAPIendpointURL}/resetrealitycheck`

  const params = {
    g: config.GAME_CONFIG.GAME_ID,
    sid: session.sid,
    loss: true,
    sessionLength: true
  }

  yield call(request, url, params)
}

/**
 * Saga that will toggle the sounds on or off.
 * It will also try to store the setting in the localStorage.
 */
export function* onMuteToggle(params) {
  const { base } = yield select()
  let { muted, mutedSFX, mutedMusic } = base
  const { external } = params || {}

  if (params && params.muted !== undefined) {
    if (muted === params.muted && muted === mutedSFX && muted === mutedMusic) {
      return
    }
    muted = params.muted
  } else { // Invert if from base, since it should then toggle
    muted = !muted
  }

  muteMusic(muted)
  muteSFX(muted)
  muteAll(muted)
  yield put(setMuteSFX(muted))
  yield put(setMuteMusic(muted))
  yield put({ type: SET_MUTE, mute: muted, external })

  if (isDesktop()) {
    setToLocalStorage('muted', `${muted}`)
  }
}

/**
 * Function that will check if sound and music are muted and then also mute all sounds if they are
 */
export function* checkMuted(mutedX) {
  const { base } = yield select()
  const { muted } = base

  if (muted) {
    muteAll(false)
    yield put({ type: SET_MUTE, mute: false })
  } else if (mutedX) {
    muteAll(true)
    yield put({ type: SET_MUTE, mute: true })
  }
}

/**
 * Saga that will toggle the music on or off.
 */
export function* onMuteMusicToggle() {
  const { base } = yield select()
  const { mutedSFX, mutedMusic } = base

  yield call(checkMuted, mutedSFX)
  muteMusic(!mutedMusic)

  yield put(setMuteMusic(!mutedMusic))
}

/**
 * Saga that will toggle the SFX on or off.
 */
export function* onMuteSFXToggle() {
  const { base } = yield select()
  const { mutedMusic, mutedSFX } = base

  yield call(checkMuted, mutedMusic)
  muteSFX(!mutedSFX)

  yield put(setMuteSFX(!mutedSFX))
}

/**
 * Saga that will set the mute all sounds on or off.
 * @param action
 */
export function onSetMute(action) {
  muteAll(action.mute)
}

/**
 * Saga that will toggle the settings screen on or off.
 */
export function* onSettingsToggle() {
  const { base } = yield select()

  yield put({
    type: SET_SETTINGSSCREEN,
    screen: base.settingScreen ? false : SETTINGSCREENS.INFO
  })
}

/**
 * Saga that will toggle the Space to Spin feature on or off.
 */
export function* onSpaceToSpinToggle() {
  const { base } = yield select()
  yield put({ type: SET_SPACE_TO_SPIN, spaceToSpin: !base.spaceToSpin })
}

/**
 * Function that handles the skip-functionality, letting the player skip the current game round.
 */
export function* onSetSkipfeature(action) {
  const { FEATURE_CONFIG = {} } = config
  const { QUICKSPIN = false, QUICKSPIN_ENABLE_DELAY = 10000 } = FEATURE_CONFIG
  const { settings } = yield select(state => state.base)
  const { quickSpinPromptShown } = yield select(state => state.base)

  if (!QUICKSPIN || settings.quickSpin || quickSpinPromptShown) { return }

  if (action.skipfeature) {
    yield put({
      type: ADD_ENABLE_QUICKSPIN,
      add: 1
    })
    yield delay(QUICKSPIN_ENABLE_DELAY)
    yield put({
      type: ADD_ENABLE_QUICKSPIN,
      add: -1
    })
  }
}

/**
- * Saga that will save the settings, when Quick spin has been toggled
- * in the UI.
- */
export function* onSetQuickspin() {
  yield call(setSavedSettings)
}

/**
 * @deprecated attemptToSpin is never called
 */
export function* attemptToSpin() {
  const { base, autoPlay } = yield select()
  const { paused, playing, response, skipfeature } = base

  if (!playing && response.ended && !paused && autoPlay.spinsLeft === 0) {
    yield put(play({ ga: 'spin' }))
  } else if (playing && !paused && !skipfeature) {
    yield put(setSkipFeature(true))
  }
}

/**
 * Saga that will update the current free rounds left.
 * @param action
 */
export function* updateFreeRoundsLeft(action) {
  const { session } = yield select()
  session.freeRoundSpins = action.spins

  yield put({
    type: UPDATE_FREEROUNDS_LEFT,
    payload: session
  })
}


/**
 * Saga that will act on the KEY_UP event.
 * @param {object} action - Object containing event information about the KEY_UP event.
 */
export function* onKeyUp(action) {
  const { base, autoPlay } = yield select()
  const { event } = action
  const { settings = {}, externalPause } = base
  const { target, keyCode } = event
  const hasMessage = base.messages.length > 0

  if (!event)
    return

  switch (keyCode) {
    case 32: { // Space
      if (target.nodeName.toLowerCase() === 'input')
        return

      event.preventDefault()
      event.stopPropagation()
      if (base.allowSpinRequests && settings.spaceToSpin && (!base.hasSplash || base.hideSplash) &&
        !base.settingScreen && !hasMessage && !externalPause && !config.disableSpaceBarSpin) {
        if (base.playing || (base.response && !base.response.ended)) {
          if (!base.skipfeature) {
            yield put(setSkipFeature(true))
          }
        } else if (autoPlay.spinsLeft === 0) {
          yield put(playRequest({ ga: GAME_ACTIONS.SPIN }))
        }
      }
      break
    }
    default: {
      break
    }
  }
}

/**
 * Saga that will update the win field and will send the client
 * the previous round, to replay it.
 */
export function* reRunLastRound() {
  const { playing, response } = yield select(state => state.base)
  if (playing) { return }

  yield put(setPlaying(true))
  yield put({
    type: UPDATE_WIN,
    win: 0
  })
  yield put({ type: GAME_ACTIONS.SPIN })

  yield delay(100)

  yield put({
    type: ON_PLAY_RESPONSE,
    response: { ...response, refresh: false, replay: true }
  })
}

/**
 * Saga that will send a choice of either declining or postponing free rounds.
 * @param action
 */
export function* sendFreeRoundAction(action) {
  const { choice } = action
  const { session, base: { response: _resp } } = yield select()
  let response = _resp

  yield put(message(null))

  if (session.sid && (choice === 'skip' || choice === 'delete')) {
    const url = `${session.gameServerAPIendpointURL}/freespins/`
    const params = {
      sid: session.sid,
      action: choice
    }

    yield put(setAllowSpinRequests(false))

    yield put(setBet(session.betAmount, false))
    const resp = yield call(request, url, params)
    response = { ..._resp, ...resp }

    yield refreshFreerounds()

    yield put(setAllowSpinRequests(true))
  }

  if (_resp.isLogin) {
    yield put(onRefresh(response))
  }

}

export function* updateBalance() {
  const { session, base: { playing } } = yield select()
  if (!session.sid) { return }

  const url = `${session.gameServerAPIendpointURL}/getbalance`
  const params = {
    sid: session.sid
  }

  const res = (yield call(request, url, params)) || 0
  if (res) {
    yield put({ type: FORCE_NEW_BALANCE, balance: res.b || 0, force: !playing })
  }
}

export function* startRestore() {
  const { response, displayFreeRound } = yield select(state => state.base)
  yield put(onStartRestore())

  if (!displayFreeRound
    && response && response.stats && response.stats.freespins
    && (response.stats.freespins.spinsended || timeUntilExpiration(response.stats.freespins.expires) <= 0)) {
    yield put(displayFreeround(true))
  }

  yield put(message({ type: MESSAGE_TYPES.GAME_RESTORE }))
  yield take(action => (action.type === SHOW_MESSAGE && action.message == null))
}